'use client'

import { useEffect, useRef } from 'react'

export default function EnhancedMouseEffects() {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const mouseRef = useRef({ x: 0, y: 0 })
  const particlesRef = useRef<Array<{
    x: number
    y: number
    vx: number
    vy: number
    life: number
    maxLife: number
    size: number
  }>>([])

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext('2d')
    if (!ctx) return

    // 设置画布大小
    const resizeCanvas = () => {
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
    }
    resizeCanvas()
    window.addEventListener('resize', resizeCanvas)

    // 鼠标移动事件
    const handleMouseMove = (e: MouseEvent) => {
      mouseRef.current = { x: e.clientX, y: e.clientY }
      
      // 创建粒子
      for (let i = 0; i < 3; i++) {
        particlesRef.current.push({
          x: e.clientX + (Math.random() - 0.5) * 20,
          y: e.clientY + (Math.random() - 0.5) * 20,
          vx: (Math.random() - 0.5) * 2,
          vy: (Math.random() - 0.5) * 2,
          life: 1,
          maxLife: Math.random() * 60 + 30,
          size: Math.random() * 3 + 1
        })
      }
    }

    // 动画循环
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      
      // 更新和绘制粒子
      particlesRef.current = particlesRef.current.filter(particle => {
        // 更新位置
        particle.x += particle.vx
        particle.y += particle.vy
        particle.life--
        
        // 计算透明度
        const opacity = particle.life / particle.maxLife
        
        // 绘制粒子
        if (opacity > 0) {
          ctx.save()
          ctx.globalAlpha = opacity
          
          // 创建径向渐变
          const gradient = ctx.createRadialGradient(
            particle.x, particle.y, 0,
            particle.x, particle.y, particle.size
          )
          gradient.addColorStop(0, '#f97316')
          gradient.addColorStop(1, 'transparent')
          
          ctx.fillStyle = gradient
          ctx.beginPath()
          ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2)
          ctx.fill()
          ctx.restore()
          
          return true
        }
        return false
      })
      
      // 绘制鼠标连接线
      if (particlesRef.current.length > 1) {
        ctx.save()
        ctx.strokeStyle = 'rgba(249, 115, 22, 0.1)'
        ctx.lineWidth = 1
        
        for (let i = 0; i < particlesRef.current.length - 1; i++) {
          const p1 = particlesRef.current[i]
          const p2 = particlesRef.current[i + 1]
          const distance = Math.sqrt(
            Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2)
          )
          
          if (distance < 100) {
            ctx.globalAlpha = (100 - distance) / 100 * 0.5
            ctx.beginPath()
            ctx.moveTo(p1.x, p1.y)
            ctx.lineTo(p2.x, p2.y)
            ctx.stroke()
          }
        }
        ctx.restore()
      }
      
      requestAnimationFrame(animate)
    }

    document.addEventListener('mousemove', handleMouseMove)
    animate()

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('resize', resizeCanvas)
    }
  }, [])

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none z-30"
      style={{ mixBlendMode: 'screen' }}
    />
  )
}